import { Injectable } from '@angular/core';
import { ComptageStatut, PreparationsLexiClient, PreparationUpdateResult } from '@lexi-clients/lexi';
import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PreparationService {
  private readonly statutsAValider = [ComptageStatut.transmis, ComptageStatut.rejete, ComptageStatut.valide];

  constructor(private readonly preparationLexiClient: PreparationsLexiClient) {}

  isStatutAValider(statut: ComptageStatut) {
    return this.statutsAValider.includes(statut);
  }

  valider(id: number, modifiedOn: string): Promise<string> {
    return lastValueFrom(this.preparationLexiClient.valider(id, modifiedOn))
      .then(
        (result: PreparationUpdateResult) => {
          if (result.erreurs?.length) {
            const msgErr = result.erreurs.reduce(
              (msg, err, i) => msg + (i > 0 ? `\n` : '') + err,
              ''
            );
            return msgErr;
          } else {
            return null;
          }
        },
        (err) => {
          return err.error ??  `Erreur inattendue: ${err}`;
        }
      );
  }
}
